import { SkeletonDisplayText } from '@shopify/polaris';

export interface GSkeletonDisplayTextProps {
  height?: `${number}ch` | `${number}%` | `${number}px`;
}
export const GSkeletonDisplayText: React.FC<GSkeletonDisplayTextProps> = (props) => {
  return (
    <div
      className="Polaris-GSkeletonDisplayText"
      style={
        {
          '--gp-skeleton-display-text-height': props.height ?? '50px',
        } as React.CSSProperties
      }
    >
      <SkeletonDisplayText maxWidth="100%" size="extraLarge" />
    </div>
  );
};
